<template>
  <el-dialog
    title="用户信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      size="small"
    >
      <el-form-item
        prop="name"
        label="用户名"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item
        prop="trueName"
        label="姓名"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.trueName"></el-input>
      </el-form-item>
      <el-form-item v-if="passwordEdit"
              prop="password"
              label="密码"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.password"> </el-input>
      </el-form-item>

      <el-form-item
        prop="phone"
        label="手机号码"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item
              prop="sex"
              label="选择性别"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.sex"
                placeholder="请选择"
                width="50"
        >

          <el-option
                  v-for="item in stateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="sinaOpenId"
              label="选择门店"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.sinaOpenId"
                placeholder="请选择"
        >
          <el-option
                  v-for="item in mdOptions"
                  :key="item.id"
                  :label="item.shop_name"
                  :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="cashing"
              label="选择角色"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.cashing"
                placeholder="请选择"
                width="50"
        >
          <el-option
                  v-for="item in roleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="disabled"
              label="选择状态"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.disabled"
                placeholder="请选择"
                width="50"
        >
          <el-option
                  v-for="item in ztOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="headimgurl"
              label="图片"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.headimgurl" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as userService from '@/api/sys/user'
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'userEditForm',
  props: {
    user: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      imgUrl: process.env.VUE_APP_API + '/moblieapp/currencyUpload',
      fileList: [],
      formEdit: true,
      accuseVisible2: true,
      passwordEdit: true,
      loading: false,
      dialogVisible: false,
      stateOptions: [
        {
          value: '0',
          label: '男'
        },
        {
          value: '1',
          label: '女'
        }
      ],
      roleOptions: [
        {
          value: '1',
          label: '店长'
        },
        {
          value: '2',
          label: '店员'
        }
      ],
      ztOptions: [
        {
          value: '1',
          label: '正常'
        },
        {
          value: '2',
          label: '禁用'
        }
      ],
      mdOptions: [],
      form: {
        businessid: '',
        businessname: '',
        sort_id: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('agentid', util.cookies.get('agentid'))
      agentService.getStoreagent(formData2).then(data => {
        this.mdOptions = data
      })
      if (this.user.userId) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.name = this.user.userCode
        form.trueName = this.user.userName
        form.phone = this.user.mobileNo
        form.sex = this.user.sex + ''
        form.sinaOpenId = parseInt(this.user.sinaOpenId)
        form.cashing = this.user.cashing + ''
        form.disabled = this.user.disabled + ''

        if (this.user.headimgurl != null && this.user.headimgurl != '') {
          form.headimgurl = this.user.headimgurl
          this.fileList = [{ url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.user.headimgurl }]
        }

        this.form = form
        // });
        this.passwordEdit = false
        this.formEdit = this.accuseVisible2
      } else {
        this.passwordEdit = true
        this.formEdit = this.accuseVisible2
        this.form = {}
      }
    },
    // 上传文件之前的钩子
    handleBeforeUpload (file) {
      let isJPG = true
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before')
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        isJPG = false
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
      }
      let size = file.size / 1024 / 1024 / 2
      if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
        isJPG = false
      }

      return isJPG // 返回false不会自动上传
    },
    // 文件超出个数限制时的钩子
    handleExceed (files, fileList) {

    },
    // 文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      this.form.headimgurl = ''
      this.dialogVisible = true
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview (file) {
      console.log('url===' + file.url)
      this.form.headimgurl = file.url
      this.dialogVisible = true
    },
    checkUserCode () {
      console.log('=========checkUserCode:' + this.form.name)
      userService
        .getCheckUser({ userCode: this.form.name, id: this.user.userId })
        .then(data => {
          if (data == 'false') {
            this.$message('该账号已存在,请更换账号试试')
            this.formEdit = true
            this.form.name = ''
          } else {
            this.formEdit = true
          }
        })
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          userService
            .getCheckUser({ userCode: this.form.name, id: this.user.userId })
            .then(data2 => {
              console.log('=========data2:' + data2)
              if (data2 == 'true') {
                this.loading = true
                userService
                  .saveUserStore({ ...this.form, id: this.user.userId, xt_id: util.cookies.get('xt_id'), agentid: util.cookies.get('agentid') })
                  .then(data => {
                    this.loading = false
                    this.dialogVisible = false
                    this.$emit('submit')
                  })
              } else {
                this.$message('该账号已存在,请更换账号试试')
              }
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
